"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrefix = isPrefix;
exports.validatePrefix = validatePrefix;
function isPrefix({ segment, validPrefixes }) {
    return validPrefixes.includes(segment);
}
function validatePrefix({ prefix, validPrefixes }) {
    if (!validPrefixes.includes(prefix)) {
        throw new Error(`Invalid prefix \`${prefix}\``);
    }
    return prefix;
}
